import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "./Admin/AdminLayout";
import Layout from "./Frontend/Layout";
import { useSelector } from "react-redux";
import ScrollToTop from "react-scroll-to-top";
import Spinner from "./Frontend/Container/Components/Spinner";
import BangaloreLayout from "./Benches/Bangalore/BangaloreLayout";
import AmravatiLayout from "./Benches/amravati/AmravatiLayout";
import AllahabadLayout from "./Benches/allahabad/AllahabadLayout";
import ChandigarhLayout from "./Benches/Chandigarh/ChandigarhLayout";
import BhubaneshwarLayout from "./Benches/Bhubaneshwar/BhubaneshwarLayout";
import BhopalLayout from "./Benches/Bhopal/BhopalLayout";
import ChennaiLayout from "./Benches/Chennai/ChennaiLayout";
import DelhiLayout from "./Benches/Delhi/DelhiLayout";
import ErnakulamLayout from "./Benches/Ernakulam/ErnakulamLayout";
import GorakhpurLayout from "./Benches/Gorakhpur/GorakhpurLayout";
import GuwahatiLayout from "./Benches/Guwahati/GuwahatiLayout";
import LucknowLayout from "./Benches/Lucknow/LucknowLayout";
import JaipurLayout from "./Benches/Jaipur/JaipurLayout";
import KolkataLayout from "./Benches/Kolkata/KolkataLayout";
import MumbaiLayout from "./Benches/Mumbai/MumbaiLayout";
import NagpurLayout from "./Benches/Nagpur/NagpurLayout";
import PatnaLayout from "./Benches/Patna/PatnaLayout";
import SecunderabadLayout from "./Benches/Secunderabad/SecunderabadLayout";
import VaranasiLayout from "./Benches/Varanasi/VaranasiLayout";
import RanchiLayout from "./Benches/Ranchi/RanchiLayout";
import TopHeader from "./Frontend/Shared/Header/TopHeader";
import benches from "./Utility/benchesData.json";

const AhmedabadLayout = lazy(() =>
  import("./Benches/ahmedabad/AhmedabadLayout")
);

const App = () => {
  return (
    <div className="ACL_App">
      <ScrollToTop
        smooth
        viewBox="0 0 24 24"
        svgPath="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"
      />
      <TopHeader />
      <Routes>
        <Route
          path="/*"
          element={
            <Layout
              benchId={benches.home.id}
              benchName={benches.home.railway_bench_name}
              benchCode={benches.home.railway_bench_code}
            />
          }
        ></Route>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<Spinner />}>
              <AdminLayout />
            </Suspense>
          }
        ></Route>
        <Route
          path="/adi/*"
          element={
            <Suspense fallback={<Spinner />}>
              <AhmedabadLayout
                benchId={benches.ahmedabad.id}
                benchName={benches.ahmedabad.railway_bench_name}
                benchCode={benches.ahmedabad.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/ald/*"
          element={
            <Suspense fallback={<Spinner />}>
              <AllahabadLayout
                benchId={benches.allahabad.id}
                benchName={benches.allahabad.railway_bench_name}
                benchCode={benches.allahabad.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/amvt/*"
          element={
            <Suspense fallback={<Spinner />}>
              <AmravatiLayout
                benchId={benches.amravati.id}
                benchName={benches.amravati.railway_bench_name}
                benchCode={benches.amravati.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/sbc/*"
          element={
            <Suspense fallback={<Spinner />}>
              <BangaloreLayout
                benchId={benches.bangalore.id}
                benchName={benches.bangalore.railway_bench_name}
                benchCode={benches.bangalore.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/bpl/*"
          element={
            <Suspense fallback={<Spinner />}>
              <BhopalLayout
                benchId={benches.bhopal.id}
                benchName={benches.bhopal.railway_bench_name}
                benchCode={benches.bhopal.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/bbs/*"
          element={
            <Suspense fallback={<Spinner />}>
              <BhubaneshwarLayout
                benchId={benches.bhubaneswar.id}
                benchName={benches.bhubaneswar.railway_bench_name}
                benchCode={benches.bhubaneswar.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/cdg/*"
          element={
            <Suspense fallback={<Spinner />}>
              <ChandigarhLayout
                benchId={benches.chandigarh.id}
                benchName={benches.chandigarh.railway_bench_name}
                benchCode={benches.chandigarh.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/mas/*"
          element={
            <Suspense fallback={<Spinner />}>
              <ChennaiLayout
                benchId={benches.chennai.id}
                benchName={benches.chennai.railway_bench_name}
                benchCode={benches.chennai.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/dli/*"
          element={
            <Suspense fallback={<Spinner />}>
              <DelhiLayout
                benchId={benches.delhi.id}
                benchName={benches.delhi.railway_bench_name}
                benchCode={benches.delhi.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/ers/*"
          element={
            <Suspense fallback={<Spinner />}>
              <ErnakulamLayout
                benchId={benches.ernakulam.id}
                benchName={benches.ernakulam.railway_bench_name}
                benchCode={benches.ernakulam.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/gkp/*"
          element={
            <Suspense fallback={<Spinner />}>
              <GorakhpurLayout
                benchId={benches.gorakhpur.id}
                benchName={benches.gorakhpur.railway_bench_name}
                benchCode={benches.gorakhpur.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/ghy/*"
          element={
            <Suspense fallback={<Spinner />}>
              <GuwahatiLayout
                benchId={benches.guwahati.id}
                benchName={benches.guwahati.railway_bench_name}
                benchCode={benches.guwahati.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/Jp/*"
          element={
            <Suspense fallback={<Spinner />}>
              <JaipurLayout
                benchId={benches.jaipur.id}
                benchName={benches.jaipur.railway_bench_name}
                benchCode={benches.jaipur.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/kol/*"
          element={
            <Suspense fallback={<Spinner />}>
              <KolkataLayout
                benchId={benches.kolkata.id}
                benchName={benches.kolkata.railway_bench_name}
                benchCode={benches.kolkata.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/lko/*"
          element={
            <Suspense fallback={<Spinner />}>
              <LucknowLayout
                benchId={benches.lucknow.id}
                benchName={benches.lucknow.railway_bench_name}
                benchCode={benches.lucknow.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/mcc/*"
          element={
            <Suspense fallback={<Spinner />}>
              <MumbaiLayout
                benchId={benches.mumbai.id}
                benchName={benches.mumbai.railway_bench_name}
                benchCode={benches.mumbai.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/ngp/*"
          element={
            <Suspense fallback={<Spinner />}>
              <NagpurLayout
                benchId={benches.nagpur.id}
                benchName={benches.nagpur.railway_bench_name}
                benchCode={benches.nagpur.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/pnbe/*"
          element={
            <Suspense fallback={<Spinner />}>
              <PatnaLayout
                benchId={benches.patna.id}
                benchName={benches.patna.railway_bench_name}
                benchCode={benches.patna.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/rnc/*"
          element={
            <Suspense fallback={<Spinner />}>
              <RanchiLayout
                benchId={benches.ranchi.id}
                benchName={benches.ranchi.railway_bench_name}
                benchCode={benches.ranchi.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/sc/*"
          element={
            <Suspense fallback={<Spinner />}>
              <SecunderabadLayout
                benchId={benches.secunderabad.id}
                benchName={benches.secunderabad.railway_bench_name}
                benchCode={benches.secunderabad.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
        <Route
          path="/bsb/*"
          element={
            <Suspense fallback={<Spinner />}>
              <VaranasiLayout
                benchId={benches.varanasi.id}
                benchName={benches.varanasi.railway_bench_name}
                benchCode={benches.varanasi.railway_bench_code}
              />
            </Suspense>
          }
        ></Route>
      </Routes>
    </div>
  );
};

export default App;
